import { AnimatePresence, motion } from 'framer-motion';
import { MessageSquare, X } from 'lucide-react';
import { useState } from 'react';

import { SendMessageConversation } from '../types/conversation';
import { ChatConversations } from './ChatConversations';
import { ChatWindow } from './ChatWindow';

export const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [conversation, setConversation] = useState<SendMessageConversation | null>(null);
  const [isChatWindow, setIsChatWindow] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="chat-button bg-[#4356ed]"
        aria-label="Open chat"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <MessageSquare className="w-6 h-6 text-white" />
        )}
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.2 }}
            className="chat-window"
            style={{
              zIndex: 2,
            }}
          >
            <div className="flex flex-col h-full z-10">
              {/* Content Area */}
              {isChatWindow ? (
                <ChatWindow
                  conversation={conversation}
                  onBack={() => {
                    setIsChatWindow(false);
                    setConversation(null);
                  }}
                  setConversation={setConversation}
                />
              ) : (
                <div className="flex-1 overflow-y-auto">
                  <ChatConversations
                    onSelectConversation={setConversation}
                    onSelectChatWindow={() => setIsChatWindow(true)}
                  />
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
